import React, { Component } from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";

import bot from "@/../../public/img/bot.svg";
import user from "@/../../public/img/user.svg";

const theme = {
  background: "#fefefe",
  headerBgColor: "#0282ce",
  headerFontColor: "#fefefe",
  headerFontSize: "20px",
  botBubbleColor: "#0282ce",
  botFontColor: "#fefefe",
  userBubbleColor: "#bfcc01",
  userFontColor: "#fefefe",
};

const steps = [
  {
    id: "1",
    message: "Hola padeler@, encantado de saludarte!",
    trigger: "2",
  },

  {
    id: "2",
    message: "Dime qué estás buscando...",
    trigger: "seleccion",
  },

  {
    id: "3",
    message: "Siento no poder ayudarte en nada más ¡Hasta la vista!",
    trigger: "preguntaVuelta",
  },

  {
    id: "seleccion",
    options: [
      { value: "f", label: "🤾 Jugar", trigger: "4A" },
      { value: "b", label: "🏋️ Entrenar", trigger: "4B" },
      { value: "c", label: "🎁 Puntos", trigger: "4C" },
    ],
  },
  {
    id: "4A",
    message:
      "Tenemos un grupo de WhatApps para organizar partitos. ¿Quieres formar parte?",
    trigger: "seleccionJugar",
  },
  {
    id: "seleccionJugar",
    options: [
      {
        value: "y",
        label: "Sí",
        trigger: "jugarSi",
      },
      { value: "n", label: "No", trigger: "preguntaVuelta" },
    ],
  },
  {
    id: "jugarSi",
    component: (
      <a
        href="https://api.whatsapp.com/send?phone=+34650291449&amp;text=Hola!%20Puedo%20formar%20parte%20del%20grupo%20🎾?"
        target="_blank"
        rel="noreferrer"
      >
        <div class="rounded-3xl p-3 max-w-full bgFusia text-white shadow-lg">
          <span>Acceder al grupo</span>
        </div>
      </a>
    ),
    trigger: "preguntaVuelta",
  },

  {
    id: "4B",
    message: "Que quieres saber?",
    trigger: "seleccionEntrenar",
  },
  {
    id: "4C",
    message: "Que quieres saber?",
    trigger: "seleccionPuntos",
  },

  {
    id: "seleccionEntrenar",
    options: [
      {
        value: "academia",
        label: "ver tarifas",
        trigger: "9",
      },
      {
        label: "Contactar con la escuela",
        trigger: "EntrenarSi",
      },
    ],
  },

  {
    id: "EntrenarSi",
    component: (
      <a
        href="https://api.whatsapp.com/send?phone=+34650291449&amp;text=Hola!%20Me%20gustar&iacute;a%20tener%20m&aacute;s%20info%20de%20la%20escuela"
        target="_blank"
        rel="noreferrer"
      >
        <div class="rounded-3xl p-3 max-w-full bgFusia text-white shadow-lg">
          <span class="icon-candadoabierto">Info Escuela</span>
        </div>
      </a>
    ),
    trigger: "preguntaVuelta",
  },

  {
    id: "seleccionPuntos",
    options: [
      {
        value: "puntos",
        label: "ver puntos",
        trigger: "10",
      },
      {
        label: "Canjear puntos",
        trigger: "CanjearSi",
      },
    ],
  },

  {
    id: "CanjearSi",
    component: (
      <a
        href="https://api.whatsapp.com/send?phone=+34650291449&amp;text=Hola,%20puedo%20canjear%20mis%20puntos?"
        target="_blank"
        rel="noreferrer"
      >
        <div class="rounded-3xl p-3 max-w-full bgFusia text-white shadow-lg">
          <span class="icon-candadoabierto">Canjear puntos</span>
        </div>
      </a>
    ),
    trigger: "preguntaVuelta",
  },

  {
    id: "9",
    component: (
      <a
        href="https://www.aravallepadel.com/academia"
        target="_blank"
        rel="noreferrer"
      >
        <div class="rounded-3xl p-3 max-w-full bgFusia text-white shadow-lg">
          <span class="icon-candadoabierto">Ver Tarifas</span>
        </div>
      </a>
    ),
    trigger: "preguntaVuelta",
  },
  {
    id: "preguntaVuelta",
    message: "Ok ¿Necesitas saber algo más?",
    trigger: "respuestaVuelta",
  },
  {
    id: "10",
    component: (
      <a
        href="https://www.aravallepadel.com/club#btnPuntos"
        target="_blank"
        rel="noreferrer"
      >
        <div class="rounded-3xl p-3 max-w-full bgFusia text-white shadow-lg">
          <span class="icon-candadoabierto">Ver puntos</span>
        </div>
      </a>
    ),
    trigger: "preguntaVuelta",
  },
  {
    id: "preguntaVuelta",
    message: "Ok ¿Necesitas saber algo más?",
    trigger: "respuestaVuelta",
  },

  {
    id: "respuestaVuelta",
    options: [
      { value: "y", label: "Sí", trigger: "2" },
      { value: "n", label: "No", trigger: "3" },
    ],
  },
];

export default class Contenido extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <ChatBot
          steps={steps}
          headerTitle="🎾 What´s up!"
          floating={false}
          botDelay={1000}
          enableSmoothScroll={true}
          botAvatar={bot}
          userAvatar={user}
        />
      </ThemeProvider>
    );
  }
}
